import React, { useState, useEffect } from 'react'

// components
import AppCard from 'src/components/AppCard'
import AppTable from 'src/components/AppTable'

// helpers
import { columnRefundList } from 'src/components/table-column/TableColumnList'
import {
  formUrlQuery,
  formSortQuery,
} from 'src/helpers/format-queries'
import Axios from 'src/helpers/axios'

const RefundList = () => {

  const [refundList, setRefundList] = useState([]);
  const [refundListCount, setRefundListCount] = useState(0);
  const [refundListPerPage, setRefundListPerPage] = useState(10);
  const [activeRefundListPage, setActiveRefundListPage] = useState(1);
  const [searchRefundListFilter, setSearchRefundListFilter] = useState("");
  const [columnRefundListSorter, setColumnRefundListSorter] = useState({ column: "id", state: "desc" });

  useEffect(() => {
    let queries = {
      search: searchRefundListFilter,
      limit: refundListPerPage,
      offset: refundListPerPage * activeRefundListPage - refundListPerPage,
      sort: formSortQuery(columnRefundListSorter),
    };
    queries = formUrlQuery(queries);
    fetchAllRefunds(queries);
  }, [
    searchRefundListFilter,
    refundListPerPage,
    activeRefundListPage,
    columnRefundListSorter,
  ]);

  const fetchAllRefunds = (queries) => {
    Axios({
      method: "get",
      url: `/api/booking/v1/refunds/manual/all?${queries}`,
    })
      .then(({ data }) => {
        const result = data && data.result
        const count = data && data.count
        const tempRefundList = result.map((d) => ({
          ...d,
          refund_uuid: d.refund && d.refund.refund_uuid,
          transaction_uuid: d.refund && d.refund.transaction_details && d.refund.transaction_details.transaction_id,
          refund_amount: d.refund && d.refund.refund_amount,
          refund_status: d.refund && d.refund.refund_status === "manual-refund" ? "Manual Refund" : "-",
        }));

        setRefundList(tempRefundList);
        setRefundListCount(count)
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <AppCard
      className='mb-4'
      headerTitle={<h4>Refund List</h4>}
      bodyContent={
        <AppTable
          refundListPage
          tableFilter
          columnFilter
          tableColumns={
            columnRefundList(
              setActiveRefundListPage,
            )
          }
          tableContent={refundList}
          contentPerPage={refundListPerPage}
          activeContentPage={activeRefundListPage}
          contentCount={refundListCount}
          searchContentFilter={searchRefundListFilter}
          setActiveContentPage={setActiveRefundListPage}
          setSearchContentFilter={setSearchRefundListFilter}
          setContentPerPage={setRefundListPerPage}
          setColumnContentSorter={setColumnRefundListSorter}
        />
      }
    />
  )
}

export default RefundList
